import { FC, ReactNode } from 'react';
import { MarkdownContent } from '@mainstage/core-components';
import {
  Box,
  Theme,
  Typography,
  makeStyles,
  useTheme,
} from '@material-ui/core';
import { WittyIcon } from '../icons/WittyIcon';
import { Feedbacks } from './Feedbacks';
import { WbUserAvatar } from '../../WbAvatar';

export interface WittyMessage {
  sender: 'witty' | 'you';
  contentMessage: string;
  isFeedbackActive?: boolean;
  customContent?: ReactNode;
}

type StyleProps = {
  sender: 'witty' | 'you';
  showHeader: boolean;
};

const useStyles = makeStyles<Theme, StyleProps>(
  theme => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: props => theme.spacing(props.showHeader ? 1 : 0.5),
      alignItems: props => (props.sender === 'you' ? 'flex-end' : 'auto'),
    },
    markdown: {
      flex: 1,
      overflow: 'auto',
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
    },
    userMessage: {
      backgroundColor: theme.palette.bkg.primary,
      width: '100%',
      borderRadius: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    avatar: {
      'div&': {
        width: '24px',
        height: '24px',
      },
    },
  }),
  { name: 'message' },
);

export const Message: FC<WittyMessage & { showHeader?: boolean }> = ({
  sender,
  contentMessage,
  isFeedbackActive = true,
  customContent,
  showHeader = true,
}) => {
  const classes = useStyles({ sender, showHeader });
  const theme = useTheme();
  return (
    <Box className={classes.container}>
      {showHeader && (
        <Box
          display="flex"
          alignItems="center"
          style={{ gap: theme.spacing(1) }}
        >
          {sender === 'witty' ? (
            <WittyIcon style={{ color: theme.palette.witboostLogo }} />
          ) : (
            <WbUserAvatar classes={{ avatar: classes.avatar }} singleInitial />
          )}
          <Typography style={{ fontWeight: 600 }} variant="body2">
            {sender.toLocaleUpperCase()}:
          </Typography>
        </Box>
      )}
      <Box className={sender !== 'witty' ? classes.userMessage : ''}>
        <MarkdownContent
          className={classes.markdown}
          content={contentMessage}
        />
        {customContent}
        {sender === 'witty' && isFeedbackActive && <Feedbacks />}
      </Box>
    </Box>
  );
};
